const makeCalendars = (departments) => {
  //  making calendars based on departments
  const calendars = departments.map((department) => {
    return new Object({
      id: department?.id,
      name: department?.department,
      color: "#f1f1f1",
      backgroundColor: department?.color,
      dragBgColor: "#9e5fff",
      borderColor: "#9e5fff",
    });
  });

  calendars.push({
    id: "0",
    name: "All",
    color: "#f1f1f1",
    dragBgColor: "#9e5fff",
    borderColor: "#9e5fff",
    backgroundColor: "#000000",
  });

  return calendars;
};

export default makeCalendars;
